import {
  CheckCircle,
  ThumbDownOutlined,
  ThumbUpOutlined,
} from '@mui/icons-material';
import { Box, ButtonGroup, Typography } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { usePostHog } from '@posthog/react';
import { DisplaySurveyType, SurveyPosition } from 'posthog-js';
import { useCallback, useEffect, useState } from 'react';
import { Button } from '~/components/Button';
import type { Searches } from '~/types';

interface SearchRatingsButtonProps {
  search: Searches.SearchObject;
  searches_uuid: string;
}
export const SearchRatingsButton = ({
  search,
  searches_uuid,
}: SearchRatingsButtonProps) => {
  const posthog = usePostHog();
  const [ready, setReady] = useState(false);

  const [rated, setRated] = useState('');
  // useLocalStorage(
  //   `search-rating-${searches_uuid}`,
  //   '',
  //   true
  // );
  const [rating, setRating] = useState<null | 1 | 5>(
    rated ? (parseInt(rated, 10) as 1 | 5) : null
  );

  const logPosthogEvent = useCallback(() => {
    posthog.capture('search_rating', {
      searches_uuid,
      search,
      rating,
    });
  }, [posthog, searches_uuid, search, rating]);

  useEffect(() => {
    if (ready) {
      return;
    }
    if (!posthog) {
      return;
    }
    posthog.getSurveys((surveys) => {
      if (
        surveys.find(
          (survey) => survey.id === '019ea2ef-1276-0000-da20-e750a9689b1f'
        )
      ) {
        setReady(true);
      }
    });
  }, [posthog, ready]);

  useEffect(() => {
    if (!rating) {
      return;
    }
    posthog.displaySurvey('019ea2ef-1276-0000-da20-e750a9689b1f', {
      displayType: DisplaySurveyType.Popover,
      selector: '.search-results-csat-container',
      position: SurveyPosition.NextToTrigger,
      ignoreConditions: true,
      ignoreDelay: true,
      initialResponses: [rating],
    });
    setRated(rating.toString());
    logPosthogEvent();
  }, [rating, logPosthogEvent, setRated, posthog]);

  return (
    <div>
      {!rated && ready && (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          className="search-results-csat-container">
          <Typography variant="body2" color="textSecondary" fontWeight={'bold'}>
            Rate these results?
          </Typography>
          <ButtonGroup variant="text" color="primary" size="small">
            <Button
              onClick={() => setRating(1)}
              className="search-results-csat search-results-csat-bad"
              data-fullstory="search-results-csat search-results-csat--bad">
              <ThumbDownOutlined htmlColor={red[400]} />
            </Button>
            <Button
              onClick={() => setRating(5)}
              className="search-results-csat search-results-csat-good"
              data-fullstory="search-results-csat search-results-csat--good">
              <ThumbUpOutlined htmlColor={green[400]} />
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {rated && (
        <Typography variant="body1" color="success">
          <CheckCircle color="success" sx={{ verticalAlign: 'middle' }} />{' '}
          Thanks for your feedback!
        </Typography>
      )}
    </div>
  );
};
